/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-concat */
/* eslint-disable max-len */
import React, { useCallback, useContext } from 'react'
import TopHeader from '../../../components/TopHeader'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
// import { useViewUserQuery, usersList } from '../../features/apiSlice'
import formatMobileNumber from '../../../CommonMethods/FormatMobileNumber'
import CustomOverLay from '../../../components/CustomOverLay'
import GlobalContext from '../../../components/Context/GloablContext'
import ErrorMessage from '../../../components/ErrorMessage'
import InputBox from '../../../components/InputBox'
import PhoneNumberValidator from '../../../components/PhoneNumberInput'
import Emptyscreenwithouttitle from '../../../components/Emptyscreenwithouttitle'
import Loader from '../../../components/Loader'
import { motion } from 'framer-motion'
import OtpInputField from '../../../components/OtpInput/index'
import { useRef, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { validateEmail } from '../../../CommonMethods/EmailValidator'
import { dataService } from '../../../services/data.services'
import { userService } from '../../../services/user.services'
import AnimatedModel from '../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../components/ConfirmationPrompt'
import { handleClear, handleSidebarAnimation } from '../../../redux/commonSlice'
import { logout } from '../authSlice'
import { handleSystemConfig } from '../../../redux/systemConfigSlice'
import MaskedEmailJS from '../../../CommonMethods/MaskedEmailJS'
import { usersList } from '../../../features/apiSlice'
import { useViewUserQuery, useGetHelpGuidePatientQuery, useEditPatientTimezoneMutation, useUpdateObserverAlertPreferencesMutation } from '../../../features/patientSlice'
import HelpGuideModal from '../../../components/HelpGuideModal'
import TimeZoneDropdown from '../../../CommonMethods/TimeZoneDropdown/index'
import { swappedTimezoneMapping } from '../../../CommonMethods/TimeZoneDropdown/TimezoneForMapping'
import AlertPreferencesSection from './AlertPreferencesSection'
import CarePartnersTable from './AlertPreferencesSection/CarePartnersTable'
import ObserverAlertPreferencesSection from './ObserverAlertPreferencesSection'

export default function Profile() {
    const auth = useSelector(state => state?.auth)
    const { userType } = auth
    // const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [logoutLoading, setLogoutLoading] = useState(false);
    const { data, isFetching, status } = useViewUserQuery({ refetchOnMountOrArgChange: true })
    // const date=convertEpochToDateFormat(data?.userDetails.created_at,dateformat)

    const otpInputRef = useRef(null);
    // const country_code=useSelector((state)=>state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const [countryCodeVal, setCountryCodeVal] = useState('')
    const country_code = useSelector(state => state?.systemConfigData?.globalVariables?.country_code)
    // const enforce_otp=useSelector(state=>state?.systemConfigData?.globalVariables?.enforce_otp_verification)
    let [enforce_otp, setEnforceOtp] = useState(false)
    const dispatch = useDispatch()
    const { setToastmessage, setToastErrorMessage, isSideBar, setToastWarnmessage } = useContext(GlobalContext)
    const [preferences, setPreference] = useState({
        "mobile_number": "",
        "country_code": country_code && country_code.match(/\d+/)?.[0],
        "otp_preference_mode": "text",
        "email_address": ""
    })
    const [countryCodes, setCountryCodes] = useState([])
    const [otp, setOtp] = useState([0, 0, 0, 0, 0, 0]);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [error, seterror] = useState(false);
    const [systemConfigloading, setSystemConfigLoading] = useState(true)
    const [verifyOtpScreen, setVerifyOtpScreen] = useState(false);
    const [errorMsg, setErrorMsg] = useState("")
    const [deletePreferenceModal, setDeletePreferenceModal] = useState(false);
    const [selectedPreference, setSelectedPreference] = useState({});
    const [emailError, setEmailError] = useState(false);
    const [verificationLoading, setVerificationLoading] = useState(false);
    const [logOutOpen, setLogOutOpen] = useState(false);
    const [preferenceLoader, setPreferenceLoader] = useState(false)
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [emptyScreen, setEmptyScreen] = useState(false);
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState({ "mobile_number": true });
    const restrict = useSelector((state) => state?.systemConfigData?.restrict)
    const [helpGuideModel, setHelpGuideModel] = useState(false);

    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParams, setQueryParams] = useState('')

    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuidePatientQuery(queryParams, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    // timezone states and api starts
    const [emptyField, setEmptyField] = useState(false)
    const [timezoneUpdate, setTimezoneUpdate] = useState(false)
    const [selectedTimeZone, setSelectedTimezone] = useState('')
    const [isOpenTimeZone, setisOpenTimeZone] = useState(false);
    const [searchTimeZoneValue, setSearchTimeZoneValue] = useState('');
    const [timezones, setTimezones] = useState([]);
    const [filteredTimezones, setFilteredTimezones] = useState([]);
    const [timezoneHistory, setTimezoneHistory] = useState('');
    const [editPatientTimezone] = useEditPatientTimezoneMutation()
    // timezone states end

    // function for timezone selection
    const handleSelectionTimezone = (item) => {
        setSelectedTimezone(item);  // Set the selected timezone
        setTimezoneHistory(item); // for activity history purpose
        setisOpenTimeZone(false);   // Close the dropdown
        setSearchTimeZoneValue('');         // Clear the search input
        setFilteredTimezones(timezones);  // Reset the timezone list to the full list

    };

    useEffect(() => {
        // setting the states for the timezone from response
        let combinedTimezone = data?.userDetails?.timezone_with_offset ? `${data?.userDetails?.timezone_with_offset}: (${data?.userDetails?.abbreviation}) ${data?.userDetails?.utcoffset}` : '';
        setSelectedTimezone(combinedTimezone);
        setTimezoneHistory(`${data?.userDetails?.timezone_with_offset}`)
    }, [data])


    const [preferenceList, setPreferenceList] = useState([]);
    const [hoverProperties, setHoverProperties] = useState({
        'hover': '',
        'hover_index': '',
        'index_to_display_modal': ''
    })

    const handleOtpPreference = (val) => {
        setEmailError(false)
        setPhoneNumberError(false)
        // Check if email_address is not empty, if not, set it to an empty string
        const updatedEmail = preferences.email_address !== "" ? "" : preferences.email_address;

        // Check if mobile_number is not empty, if not, set it to an empty string
        const updatedMobileNumber = (val === "email" && preferences.mobile_number !== "") ? "" : preferences.mobile_number;

        setPreference({
            ...preferences,
            "otp_preference_mode": val,
            "email_address": updatedEmail,
            "mobile_number": updatedMobileNumber
        });
    };

    const fetchCountryCodes = async () => {
        const res = await userService.getCountryCodes();
        // const extractedValues = res.data.map((country) => country.callingCodes[0]+'\t'+'-'+'\t'+'('+country.name+')');
        let uniqueValues = [...new Set(res?.data?.map((country) => country.callingCodes[0] + '\t' + '-' + '\t' + '(' + country.alpha3Code + ')'))];
        setCountryCodes(uniqueValues)
    }
    const fetchSystemConfigData = useCallback(async () => {
        setSystemConfigLoading(true)
        let response
        response = await dataService.GetAPI(`system-configuration/`);
        if (response?.error === false) {
            setSystemConfigLoading(false)
            setCountryCodeVal(response?.data?.global_variables?.country_code.match(/\d+/)?.[0])
            dispatch(handleSystemConfig(response?.data?.data))
            setEnforceOtp(response?.data?.enforce_otp_verification)
        }
        setSystemConfigLoading(false)

    }, [])



    useEffect(() => {
        setPreference((prev) => ({
            ...prev,
            country_code: `+ ${(country_code ? country_code.match(/\d+/)?.[0] || "" : "")}`
        }));
        fetchCountryCodes()
        fetchSystemConfigData()
    }, [])

    const handleUserInput = (id, value) => {
        setEmailError(false)
        setPhoneNumberError(false)
        const isMobileNumber = id === "mobile_number";
        const sanitizedOption = isMobileNumber ? value.replace(/\D/g, "") : value;
        const isValid = isMobileNumber ? /^[1-9]\d*$/.test(sanitizedOption) : true;
        setPreference((prev) => ({
            ...prev,
            [id]: isValid ? value : sanitizedOption
        }));
        if (!isValid) {
            setEmailError(false);
        }
    };




    const handleCountryCode = (val) => {
        setPreference({
            ...preferences,
            "country_code": val
        })
    }
    const handleVerification = async () => {
        setVerificationLoading(true)
        if (preferences.otp_preference_mode === 'email' && validateEmail(preferences?.email_address.trim())) {
            setEmailError(true);
            setVerificationLoading(false)
            return
        }
        if ((preferences.otp_preference_mode === 'text' || preferences.otp_preference_mode === 'voice') && !(isPhoneNumberValid.mobile_number)) {
            setVerificationLoading(false)
            return;
        }
        const body =
        {
            "country_code": preferences.otp_preference_mode === 'email' ? '' : (countryCodeVal === '' ? `+${country_code?.trim()}` : `+${countryCodeVal?.trim()}`),
            "preference": preferences.email_address === '' ? preferences.mobile_number : preferences.email_address.trim(),
            "otp_preference_mode": preferences.otp_preference_mode,
            "restrict": true
        }
        const response = await userService.verifyPreference(body)
        if (response?.error === false) {
            setVerifyOtpScreen(true)
            setVerificationLoading(false)
        } else if (response?.error === true && response?.message?.response?.status === 409) {
            setToastErrorMessage(response?.message?.response?.data?.message)
            setVerificationLoading(false)
        }
        else if (response?.error === true && response?.message?.response?.status === 400) {
            setToastErrorMessage(response?.message?.response?.data?.message)
            setVerificationLoading(false)
        } else {
            setVerificationLoading(false)
            setToastErrorMessage('Something went wrong')
        }

    }

    const handleFetchPreferenceList = async () => {
        setPreferenceLoader(true)
        const response = await userService.preferenceList();
        if (response?.error === false && response?.data?.data?.length > 0) {
            setPreferenceList(response?.data?.data)
            setPreferenceLoader(false)
            setEmptyScreen(false)
        } else {
            setEmptyScreen(true)
            setPreferenceLoader(false)
        }
    }

    useEffect(() => {
        setOtp(Array(6).fill(""))
        handleFetchPreferenceList()
        //handleFetchProfileDetails()
    }, [])

    useEffect(() => {
        if (userType === 'patient-user') {
            setQueryParams('type=patients-profile');
        } else {
            setQueryParams('type=observers-profile');
        }
    }, [userType]);

    useEffect(() => {
        if (queryParams) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParams]);


    const handleOTPVerification = async (e) => {
        e.preventDefault();
        setLoading(true)
        const val = otp.toString().replace(/,/g, '')
        const body = {
            otp: val
        }
        const response = await userService.verifyOtp(body)
        if (response?.error === false) {
            setToastmessage(response?.data?.message)
            handleFetchPreferenceList()
            setLoading(false)
            setPreference({
                "mobile_number": "",
                "country_code": "",
                "otp_preference_mode": "text",
                "email_address": ""
            });
            setVerifyOtpScreen(false)
            setOtp(Array(6).fill(""))
        } else {
            setLoading(false)
            setVerifyOtpScreen(true)
            if (response?.message?.response?.data?.message === "Invalid OTP entered 3 times, your preferences couldn't be saved. Please re-enter your preferences") {
                setToastWarnmessage(response?.message?.response?.data?.message)
                setOtp(Array(6).fill(""))
                setPreference({
                    "mobile_number": "",
                    "country_code": "",
                    "otp_preference_mode": "text",
                    "email_address": ""
                });
                setVerifyOtpScreen(false)

            } else {
                //setOtp(Array(6).fill(""))
                seterror(true)
                setErrorMsg(response.message.response.data.message)
                // setToastErrorMessage(response.message.response.data.message)
            }
        }
    };

    const handleLogout = async () => {
        setLogoutLoading(true)
        const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
        dispatch(handleClear())
        await userService.logout()
        dispatch(logout());
        dispatch(usersList.util.resetApiState())
        localStorage.setItem('arcm_trust_browser_token', browserIdValue);
        dispatch(handleSidebarAnimation(true))
        setToastmessage('Logout successful')
        navigate('/')
        setLogoutLoading(false)
    }

    const openDeleteModal = (item) => {
        // Check if observer is trying to delete mobile number preference while SMS alerts are enabled
        if (userType === 'observer') {
            // Alert preferences are in userDetails from view-profile API
            const userDetails = data?.userDetails || {};
            const isSmsAlertEnabled = userDetails.sms_alert === true || userDetails.sms_alert === "true" || userDetails.sms_alert === 1;
            const isReadingReceivedEnabled = userDetails.reading_received_alert === true || userDetails.reading_received_alert === "true" || userDetails.reading_received_alert === 1;
            
            // Check if this preference contains a mobile number (text or voice mode)
            const isMobileNumberPreference = item.otp_preference_mode === 'text' || item.otp_preference_mode === 'voice';
            
            if (isMobileNumberPreference && (isSmsAlertEnabled || isReadingReceivedEnabled)) {
                setToastErrorMessage('Cannot delete mobile number preference while SMS alerts are enabled. Please disable SMS alerts first.');
                return;
            }
        }

        if ((enforce_otp === true || enforce_otp === 'true') && preferenceList.length === 1) {
            setToastErrorMessage('Atleast one preference is required')
        }
        else {
            setSelectedPreference(item)
            setDeletePreferenceModal(true)
        }

    }

    const handleDeletePreferences = async () => {
        setDeleteLoading(true)
        try {
            const response = await userService.deletePreference(selectedPreference._id);
            if (response?.error === false) {
                setDeleteLoading(false)
                setPreferenceLoader(false)
                setDeletePreferenceModal(false)
                setToastmessage('Mode of preference deleted successfully')
                handleFetchPreferenceList()
            }
        } catch (e) {

            setDeleteLoading(false)
            setDeletePreferenceModal(false)
            setPreferenceLoader(false)
            setToastErrorMessage('Error while deleting mode of preference')
        }


    }
    const handleSelectCountryCode = (item) => {
        setPreference((prev) => ({
            ...prev,
            country_code: `+${parseInt(item.match(/\d+/)?.[0], 10)}`
        }));
        setCountryCodeVal(`+${parseInt(item.match(/\d+/)?.[0], 10)}`)
    }





    const handleCancel = () => {
        setVerifyOtpScreen(false)
        setPreference({
            "mobile_number": "",
            "country_code": country_code && country_code.match(/\d+/)?.[0],
            "otp_preference_mode": "text",
            "email_address": ""
        });
        handleFetchPreferenceList()
        setOtp(Array(6).fill(""))
    }

    useEffect(() => {
        if (otpInputRef.current) {
            otpInputRef.current.focus();
        }
    }, [otp]);

    const handleUpdateTimezoneHandler = async () => {
        setisOpenTimeZone(false)
        try {
            setTimezoneUpdate(true)
            const selectedKey = selectedTimeZone.split(':')[0];

            // Check if the key exists in the swappedTimezoneMapping
            const timezone = swappedTimezoneMapping[selectedKey] || selectedKey;
            let body = {
                "timezone": timezone,
                "timezone_with_offset": timezoneHistory.split(':')[0],
            }
            const editRes = await editPatientTimezone({ body })
            //dispatch(handleIsAPICall(true))
            if (editRes?.error?.data?.message) {
                setToastErrorMessage(editRes?.error?.data?.message)
                setTimezoneUpdate(false)
            }
            else {
                setToastmessage('Time zone updated successfully');
                setTimezoneUpdate(false)
            }

        } catch (error) {
            setTimezoneUpdate(false);
            setToastErrorMessage(error.message)
        }
    }

    return (
        <>
            {verifyOtpScreen && userType !== 'super-admin' ?
                <>
                    <TopHeader title={"Profile"} />
                    <div className='flex flex-col justify-center items-center h-screen m-auto'>
                        <div className='w-full'>
                            <h1 className='mt-6 text-[36px] font-normal text-[#000] text-center'>OTP Verification</h1>
                            <h1 className='text-lg font-normal text-[#777C88] text-center mb-[55px]'>
                                Enter the 6-digit OTP sent to {preferences.otp_preference_mode === 'email'
                                    ? MaskedEmailJS(preferences.email_address)
                                    : `${countryCodeVal === ''
                                        ? `+${country_code} ${preferences.mobile_number?.slice(0, 2) + '*'.repeat(preferences?.mobile_number?.length - 4) + preferences?.mobile_number?.slice(-2)}`
                                        : `+${countryCodeVal} ${preferences.mobile_number?.slice(0, 2) + '*'.repeat(preferences?.mobile_number?.length - 4) + preferences?.mobile_number?.slice(-2)}`
                                    }`
                                }
                            </h1>
                            <form onSubmit={(e) => handleOTPVerification(e)}>
                                <div className="digit-group flex justify-center pt-1.5">
                                    <OtpInputField
                                        onChange={setOtp}
                                        inputs={otp}
                                        setInputs={setOtp}
                                        value={otp}
                                        inputType="tel"
                                        shouldAutoFocus
                                        inputStyle="w-14 h-12 border-b-2 sm:mr-6 mr-5 border-[#A9B2BE] bg-[transparent] outline-0 text-center text-xs4 font-normal otp-input err-otp text-[#0D1B2A]"
                                        numInputs={6}
                                        error={error}
                                        seterror={seterror}
                                        renderInput={(props) => <input {...props} />}
                                        separator={<span></span>}

                                    />
                                </div>
                                {/* errormessage */}
                                {error && <ErrorMessage error={error} message={errorMsg} classKey="text-xs font-normal text-[#C81720] mt-5 text-center" />}

                                <div className='flex justify-center'>
                                    <button type='submit'
                                        id="otp-form"
                                        disabled={otp.includes("") || loading || errorMsg === "Invalid session for the user."}
                                        className='w-[290px] mt-8 py-2 px-4 text-lg font-semibold text-[#fff] rounded-[16px] 
                            bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]'>
                                        {!loading ? ' Verify OTP' : <span>{<Loader />}</span>}
                                    </button>
                                </div>
                                <div className='flex justify-center'>
                                    <button
                                        disabled={loading}
                                        className='w-[290px] px-2.5 py-2 border border-[#972E4C] h-fit rounded-[16px] text-center text-lg font-normal text-[#972E4C] m-auto mt-[30px]'
                                        onClick={() => handleCancel()}
                                    >{`I didn't receive the OTP`}</button></div>
                            </form>
                        </div>
                    </div>
                </>
                :
                <>
                    <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full scrollbar_purple  overflow-x-hidden'>
                        <TopHeader title={`Profile`} />
                        {((isFetching && status !== "fulfilled") || systemConfigloading) ? <CustomOverLay Active text="Loading Profile Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> : <>

                            <div className='bg-white rounded-lg xl:px-[48px] px-7 h-customh3 overflow-x-auto scrollBar-hidden'>
                                <div className='sticky top-0 left-0 bg-white pt-[6px] z-[1]'>
                                    <div className="flex justify-between items-center ">
                                        <div className='flex items-center'>
                                            <h1 className='text-xl font-normal text-[#000000]'>My Profile</h1>
                                            <span onClick={() => setHelpGuideModel(true)} className=' ml-2 cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span>

                                        </div>

                                        <div className='flex items-center gap-3 mr-[9px]'>
                                            <Link to={'/profile/update-password'} onClick={() => { dispatch(handleSidebarAnimation(false)) }} className={`${userType === 'super-admin' ? 'hidden' : 'min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center text-base font-semibold text-[#972E4C]'}`}>
                                                Update Password
                                            </Link>
                                            {(restrict === true || restrict === 'true') &&
                                                <button id='logout' onClick={() => setLogOutOpen(true)} className={`${userType === 'super-admin' ? 'hidden' : 'min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center text-base font-semibold text-[#972E4C]'}`}>
                                                    Logout
                                                </button>}
                                        </div>
                                    </div>
                                    <div className="flex items-center mb-[18px] pt-3.5 pb-1 bg-white">
                                        <p className="text-xl font-semibold text-[#000000]">{data?.userDetails?.last_name} {data?.userDetails?.first_name} {data?.userDetails?.middle_name}</p>
                                        <p className="text-sm font-normal text-[#000000] px-2">
                                            {userType === "patient-user" ? data?.userDetails?.patient_id : data?.userDetails?.user_id}
                                        </p>
                                        {data?.userDetails?.status === 'inactive' ?
                                            <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> :
                                            <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                        }
                                    </div>
                                </div>

                                {
                                    <div className="pr-2.5">
                                        {userType === "patient-user" ?
                                            <div className="flex -mx-1 flex-wrap">
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Username</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.user_name}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Email Address</p>
                                                        <p data-testid="email-address" className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.user_name}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.mobile_number !== "" ? data?.userDetails?.country_code2 + "\t" + formatMobileNumber(data?.userDetails?.mobile_number) : "-"}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Main Number</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.country_code1} {formatMobileNumber(data?.userDetails?.main_number)}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Date of Birth</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.date_of_birth}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Age</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.age}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-2/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Gender</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.gender}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Weight(lbs)</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.weight_lbs}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Weight(kg)</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.weight_kgs}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Primary Identifier</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.primary_identifier === "" ? "-" : data?.userDetails?.primary_identifier}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Secondary Identifier</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.secondary_identifier === "" ? "-" : data?.userDetails?.secondary_identifier}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Onboarding Date</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.onboarding_date === "" ? "-" : data?.userDetails?.onboarding_date}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-3/4 w-2/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Address</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.address === "" ? "-" : data?.userDetails?.address}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Organization Name</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.organization_name}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Sub - Division Name</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.subdivision_name}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Onboarding Date</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.onboarding_date === "" ? "-" : data?.userDetails?.onboarding_date}</p>
                                                    </div>
                                                </div>
                                                <div className="2xl:w-1/4 w-1/3 px-1 mb-5">
                                                    <div className="w-full">
                                                        <p className="text-sm font-normal text-[#000]">Monitoring Status</p>
                                                        <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                            {data?.userDetails?.monitoring_status}</p>
                                                    </div>
                                                </div>
                                                <div className='2xl:w-1/4 w-1/3 px-1 mb-5'>
                                                    <div className='w-full'>
                                                        <TimeZoneDropdown
                                                            label={`Time Zone*`}
                                                            placeholder={'Select patient time zone'}
                                                            id={'patient_timezone'}
                                                            disabled={false}
                                                            selectedTimezone={selectedTimeZone}
                                                            setisOpenTimeZone={setisOpenTimeZone}
                                                            isOpenTimeZone={isOpenTimeZone}
                                                            handleSelectionTimezone={handleSelectionTimezone}
                                                            setSelectedTimezone={setSelectedTimezone}
                                                            setSearchValue={setSearchTimeZoneValue}
                                                            searchValue={searchTimeZoneValue}
                                                            emptyField={emptyField && selectedTimeZone.length === 0}
                                                            timezones={timezones}
                                                            setTimezones={setTimezones}
                                                            filteredTimezones={filteredTimezones}
                                                            setFilteredTimezones={setFilteredTimezones}
                                                        />
                                                    </div>

                                                </div>
                                                <button type='button'
                                                    id="update"
                                                    data-testid={"add_patient"}
                                                    disabled={timezoneUpdate || selectedTimeZone.length === 0 || selectedTimeZone === data?.userDetails?.timezone_with_offset}
                                                    onClick={handleUpdateTimezoneHandler}
                                                    className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-5 w-[148px] ml-4 h-fit
                                        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                                    {!timezoneUpdate ? ' Update' : <span>{<Loader />}</span>}
                                                </button>

                                            </div>
                                            :
                                            <>
                                                <div className="flex -mx-1 flex-wrap">
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Username</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {data?.userDetails?.user_name}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Email Address</p>
                                                            <p data-testid="email-address" className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {data?.userDetails?.email_address}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {data?.userDetails?.mobile_number !== "" ? data?.userDetails?.mobile_country_code + "\t" + formatMobileNumber(data?.userDetails?.mobile_number) : "-"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Main Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {data?.userDetails?.main_country_code} {formatMobileNumber(data?.userDetails?.main_number)}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Organization Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {data?.userDetails?.organization_name === "" ? "-" : data?.userDetails?.organization_name}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Sub Division Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {data?.userDetails?.subdivision_name === "" ? "-" : data?.userDetails?.subdivision_name}</p>
                                                        </div>
                                                    </div>

                                                    <div className="w-full px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Address</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {data?.userDetails?.address === "" ? "-" : data?.userDetails?.address}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='flex items-center mb-3.5'>
                                                    <h1 className='text-lg font-normal text-[#000000] min-w-max'>Associated Patient</h1>
                                                    <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                                                </div>
                                                <div className="flex -mx-1 flex-wrap">
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Patient ID</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {(data?.userDetails?.patient_id === "" || data?.userDetails?.patient_id === undefined) ? "-" : data?.userDetails?.patient_id}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Patient Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {(data?.userDetails?.patient_last_name === "" || data?.userDetails?.patient_last_name === undefined) ? "-" : <>{data?.userDetails?.patient_last_name} {data?.userDetails?.patient_first_name} {data?.userDetails?.patient_middle_name}</>}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {(data?.userDetails?.contacts?.length > 0 || data?.userDetails?.case_managers?.length > 0) &&
                                            <>
                                                <div className='flex items-center my-3.5'>
                                                    <h1 className='text-lg font-normal text-[#000000] min-w-max'>Additional Contact Details</h1>
                                                    <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                                                </div>
                                                <div className="flex -mx-[7px] flex-wrap mb-6">
                                                    {data?.userDetails?.contacts?.length > 0 &&
                                                        <div className="w-1/2 px-[7px]">
                                                            <div className="w-full border border-[#CCE7E7] rounded-[4px] bg-[#E5F3F3] pt-5 px-2.5">
                                                                <h1 className='text-lg font-normal text-[#000000] w-full pb-3 border-b-[2px] border-[#972E4C]'>Emergency Contact Details (First entry is highest priority)</h1>
                                                                <div className='px-2.5'>
                                                                    {data?.userDetails?.contacts.map((contact, index) => (
                                                                        <div key={index} className={`flex -mx-2.5 py-6 ${index !== 0 ? 'border-t-[4px] border-[#CCE7E7]' : ''}`}>
                                                                            <div className='w-1/2 pl-2.5 pr-1'>
                                                                                <div className="w-full">
                                                                                    <p className="text-sm font-normal text-[#000]">Name</p>
                                                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                                        {contact.name !== "" ? contact.name : '-'}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                            <div className='w-1/2 pl-2.5 pr-1'>
                                                                                <div className="w-full">
                                                                                    <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                                        {contact.contact_number !== "" ?
                                                                                            contact.country_code + "\t" + formatMobileNumber(contact.contact_number) :
                                                                                            "-"}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }

                                                    {data?.userDetails?.case_managers?.length > 0 &&
                                                        <div className="w-1/2 px-[7px]">
                                                            <div className="w-full border border-[#CCE7E7] rounded-[4px] bg-[#E5F3F3] pt-5 px-2.5">
                                                                <h1 className='text-lg font-normal text-[#000000] w-full pb-3 border-b-[2px] border-[#972E4C]'>Case Manager Contact Details (First entry is highest priority) </h1>
                                                                <div className='px-2.5'>
                                                                    {data?.userDetails?.case_managers.map((caseManager, index) => (
                                                                        <div key={index} className={`flex -mx-2.5 py-6 ${index !== 0 ? 'border-t-[4px] border-[#CCE7E7]' : ''}`}>
                                                                            <div className='w-1/2 pl-2.5 pr-1'>
                                                                                <div className="w-full">
                                                                                    <p className="text-sm font-normal text-[#000]">Name</p>
                                                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                                        {caseManager.name !== "" ? caseManager.name : '-'}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                            <div className='w-1/2 pl-2.5 pr-1'>
                                                                                <div className="w-full">
                                                                                    <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                                                    <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                                        {caseManager.contact_number !== "" ?
                                                                                            caseManager.country_code + "\t" + formatMobileNumber(caseManager.contact_number) :
                                                                                            "-"}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </>
                                        }
                                        {userType === "patient-user" && <AlertPreferencesSection />}
                                        {userType === "observer" && <ObserverAlertPreferencesSection />}
                                        <div className='flex items-center my-3.5'>
                                            <h1 className='text-lg font-normal text-[#000000] min-w-max'>Preference mode of receiving OTP</h1>
                                            <div className='relative w-full h-[1px] bg-[#008586] ml-3 down-arraow'></div>
                                        </div>
                                        <div className="mt-3 w-full border border-[#C5C9DA] rounded-sm px-6 pt-[22px] pb-[12px]">
                                            <div className="flex items-center">
                                                <p id="add_otp_preference" className="text-xl font-normal text-[#000000]">Add OTP Preference</p>
                                            </div>
                                            <div className='w-full flex tm:flex-nowrap flex-wrap flex-start'>
                                                <div className='flex items-start mb-[15px] justify-center pt-[23px]'>
                                                    <div className='rounded-[16px] border flex border-[#C5C9DA]  py-1 items-center'>
                                                        <p
                                                            onClick={() => handleOtpPreference("text")}
                                                            id='text'
                                                            className={`hover:text-[#972E4C] ${preferences.otp_preference_mode === 'text' ? 'text-[#972E4C]' : 'text-[#777C88]'}  text-[14px] font-normal leading-normal ${preferences.otp_preference_mode === 'text' ? 'bg-[#E7CBD2]' : ''} py-[6px] px-[12px] rounded-[12px] mx-[3px] cursor-pointer`}>
                                                            Text
                                                        </p>
                                                        <p
                                                            onClick={() => handleOtpPreference("voice")}
                                                            id='voice'
                                                            className={`hover:text-[#972E4C] ${preferences.otp_preference_mode === 'voice' ? 'text-[#972E4C]' : 'text-[#777C88]'} text-[14px] font-normal leading-normal ${preferences.otp_preference_mode === 'voice' ? 'bg-[#E7CBD2]' : ''} py-[6px] px-[12px] rounded-[12px] mx-[3px] cursor-pointer`}>
                                                            Voice
                                                        </p>
                                                        <p
                                                            onClick={() => handleOtpPreference("email")}
                                                            id='email'
                                                            className={`hover:text-[#972E4C] ${preferences.otp_preference_mode === 'email' ? 'text-[#972E4C]' : 'text-[#777C88]'} text-[14px] font-normal leading-normal ${preferences.otp_preference_mode === 'email' ? 'bg-[#E7CBD2]' : ''} py-[6px] px-[12px] rounded-[12px] mx-[3px] cursor-pointer`}>
                                                            Email
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className='tn:w-1/3  xl:pl-[41px] pl-[20px] '>
                                                    <div className={`w-full mb-[35px]`}>
                                                        <PhoneNumberValidator
                                                            label={"Telephone Number *"}
                                                            placeholder={"Enter Telephone Number"}
                                                            id={"mobile_number"}
                                                            data_testid={"mobile_number"}
                                                            htmlFor={"mobile_number"}
                                                            value={preferences.mobile_number}
                                                            emptyField={false}
                                                            handleOnChangeInput={handleUserInput}
                                                            isCode={true}
                                                            countryCodeList={countryCodes}
                                                            handleCountryCode={handleCountryCode}
                                                            handleSelectCountryCode={handleSelectCountryCode}
                                                            countryCodeVal={countryCodeVal}
                                                            disabled={(preferences.otp_preference_mode === 'email') ? true : false}
                                                            maxLength={30}
                                                            preferences={preferences}
                                                            setCountryCodeVal={setCountryCodeVal}
                                                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                            isPhoneNumberValid={isPhoneNumberValid.mobile_number}

                                                        />
                                                    </div>
                                                    {phoneNumberError && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438]  '} message={"Invalid telephone number"} />}
                                                </div>

                                                <div className={`tn:w-1/3 tn:pr-0 pr-[20px]   xl:px-[41px] ${isSideBar ? ' pl-[20px]' : ""} tn:pl-[20px]`}>
                                                    <div className={`w-full ${emailError ? 'mb-[15px]' : 'mb-[35px]'}`}>
                                                        <InputBox
                                                            label={"Email Address *"}
                                                            placeholder={"Enter Email Address"}
                                                            id={"email_address"}
                                                            data_testid={"email_address"}
                                                            htmlFor={"email_address"}
                                                            value={preferences.email_address}
                                                            // emptyField={emptyField && preferences?.email_address?.trim() === "" && preferences?.mobile_number?.trim() === ""}
                                                            // emailError={emailError.email_error}
                                                            handleOnChangeInput={handleUserInput}
                                                            disabled={(preferences.otp_preference_mode === 'text' || preferences.otp_preference_mode === 'voice') ? true : false}
                                                            emailError={emailError}
                                                        />
                                                    </div>
                                                    {emailError && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438]'} message={"Invalid email address"} />}
                                                </div>

                                                <button
                                                    className="mt-[23px] tm:w-[250px] w-[210px] bg-[#972E4C] text-white py-2.5 rounded-[16px] text-lg font-normal h-fit mr-[16px] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]"
                                                    id='verification_btn'
                                                    disabled={(preferences.mobile_number === '' && preferences.email_address === '') || verificationLoading || !isPhoneNumberValid}
                                                    onClick={() => handleVerification()}
                                                >{verificationLoading ? <Loader /> : 'Save Preference'}
                                                </button>
                                            </div>
                                        </div>
                                        {userType !== 'super-admin' && <>
                                            <div className="flex items-center my-[20px]">
                                                <p id="preference_list" className="text-xl font-normal text-[#000000]">OTP Preference List</p>
                                            </div>
                                            {emptyScreen ? <Emptyscreenwithouttitle FirstPTag={"No OTP preferences added yet"} /> :
                                                (
                                                    preferenceLoader ? <CustomOverLay Active text="Loading Preference List..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened_sidebar_overlay2' : 'overlay-list2'}`} /> : <div className="border border-[#EDD7E1] rounded  overflow-auto scrollBar-hidden mt-3.5 mb-3.5">
                                                        <table aria-label="Outside Table" className="w-full table-auto">
                                                            <thead>
                                                                <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm">
                                                                    <th id="id" className="px-3 py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Email Address
                                                                        </span>
                                                                    </th>
                                                                    <th id="sub_division" className="px-3 py-2 min-w-[200px]">
                                                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Mobile Number
                                                                        </span>
                                                                    </th>
                                                                    <th id="sub_division" className="px-3 py-2 min-w-[200px]">
                                                                        <span className="flex items-center justify-start text-sm font-normal text-[#000000]">OTP Preference Mode
                                                                        </span>
                                                                    </th>
                                                                    <th id='action' className="px-3 py-2 rounded-tr-[2px] rounded-br-[2px] bg-[#EDD7E1] max-w-[245px] sticky right-0 pl-[104px]">
                                                                        <span className="flex items-center justify-center text-end text-sm font-normal text-[#000000]">Action
                                                                        </span>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {preferenceList.map((item, index) => (
                                                                    //${selectedPreference._id === item._id ? 'bg-[#F8EEF1]' : 'bg-[#fff]'}
                                                                    <tr key={index} className={` hover:bg-[#F8EEF1] h-[45px] table-tr`}>
                                                                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">{item.otp_preference_mode === 'email' ? item.preference : '-'}</td>
                                                                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{(item.otp_preference_mode === 'text' || item.otp_preference_mode === 'voice') ? item.country_code + ' ' + formatMobileNumber(item.preference) : '-'}</td>
                                                                        <td className="px-3 py-2 text-sm text-start font-normal text-[#031624]">{item.otp_preference_mode === 'email' ? "Email" : item.otp_preference_mode === 'text' ? "Text" : "Voice"}</td>
                                                                        {/* ${selectedPreference._id === item._id ? 'bg-[#F8EEF1]' : 'bg-[#fff]'} */}
                                                                        <td className={`px-8 py-2 text-sm text-end font-normal sticky right-0 max-w-[245px] text-[#031624] rounded-tr-[2px] rounded-br-[2px] min-w-[50px] last-td `}>
                                                                            <div className="flex justify-center ">
                                                                                <div onMouseEnter={() => { setHoverProperties((prev) => ({ ...prev, hover: 'modify', hover_index: index })) }}
                                                                                    onMouseLeave={() => { setHoverProperties((prev) => ({ ...prev, hover: '', hover_index: null })) }} className="px-8  min-w-[200px]">
                                                                                    {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index)) || (hoverProperties.index_to_display_modal === index)) ? <>
                                                                                        <motion.div
                                                                                            initial={{ opacity: 1, x: 0, y: 0 }}
                                                                                            animate={{ opacity: 1, x: -45, y: 0 }}
                                                                                            transition={{ delay: 0.2, duration: 0.5 }}
                                                                                            exit={{ opacity: 0.5 }}
                                                                                            className=''
                                                                                        >
                                                                                            <button
                                                                                                onClick={() => { openDeleteModal(item) }}

                                                                                            >
                                                                                                <img src="/images/deleteicon-pink.svg" alt="img" className="mx-auto w-5 mr-3" /></button>
                                                                                        </motion.div>
                                                                                    </> : <button
                                                                                        onClick={() => { openDeleteModal(item) }}
                                                                                        id={index + 'pref_remove'}
                                                                                    >
                                                                                        <img src="/images/deleteicon-pink.svg" alt="img" className="mx-auto w-5 mr-3" /></button>}
                                                                                    {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index)) || (hoverProperties.index_to_display_modal === index)) &&
                                                                                        <motion.div
                                                                                            initial={{ opacity: 0, x: 0, y: 0 }}
                                                                                            animate={{ opacity: 1, x: 0, y: 0 }}
                                                                                            transition={{ delay: 0.2, duration: 0.5 }}
                                                                                            exit={{ opacity: 0.5 }}
                                                                                            className=''
                                                                                        >
                                                                                            <div className='relative ml-5 cursor-pointer mt-[-25px]' onClick={() => { openDeleteModal(item) }} >
                                                                                                <p className="text-sm ml-10  font-normal text-[#972E4C] ">Delete</p>
                                                                                            </div>
                                                                                        </motion.div>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )
                                            }
                                        </>}
                                        {userType === "patient-user" && <CarePartnersTable />}
                                    </div>
                                }

                            </div>
                        </>}
                    </div>

                </>
            }

            {deletePreferenceModal &&
                <AnimatedModel key="logout-model"
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleDeletePreferences}
                            handleClose={() => { setDeletePreferenceModal(false); setSelectedPreference({}) }}
                            tittle={`Delete`}
                            disabled={deleteLoading}
                            message={
                                (preferenceList.length === 1 && enforce_otp === true)
                                    ? 'This is your only preference. If you delete it, you would need to replace it with a new one. Are you sure you want to delete this mode of preference?'
                                    : (preferenceList.length === 1 && enforce_otp === false)
                                        ? 'This is your only preference. If you delete it, you would be turning off OTP verification.Are you sure you want to delete this mode of preference?'
                                        : 'Are you sure you want to delete this mode of preference?'
                            } buttonName={`Delete`}
                            loadingActivation={deleteLoading}
                        />
                    }
                />
            }
            {logOutOpen &&
                <AnimatedModel key="logout-model"
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleLogout}
                            handleClose={() => setLogOutOpen(false)}
                            tittle={`Logout`}
                            message={`Are you sure you want to logout?`}
                            buttonName={`Logout`}
                            disabled={logoutLoading}
                            loadingActivation={logoutLoading}
                        />
                    }
                />
            }
            {(helpGuideModel && helpguidestatus === "fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
            }

        </>
    )
}
